// Toasts have no fixed home: anything outside an open `showModal()` dialog is
// inert, so one is built inside whichever dialog is top-most when it arrives.
//
// A task, not a microtask: Turbo awaits `nextRepaint()` per stream element —
// one shared animation frame while the tab is visible, a separate `setTimeout`
// each while it is hidden — so a microtask resolves inside the first element,
// dropping the toast into a dialog the next one replaces.
//
// A response that closes a dialog must still remove it *before* it sends the
// toast, or the host picked here is the one about to go, and the toast with it.
export function toast () {
  const content = this.templateContent
  if (!content.children.length) return

  setTimeout(() => showToast(content))
}

// For a toast the client raises itself, with no stream to ride in on.
export function showToast (content) {
  flashTrayIn(topMostHost()).append(content)
}

// The tray is client state (toasts run on their own timers, the server renders
// it empty), so a morph never touches it — but a 422 re-render carries the
// failed form's `flash.now`, so its toasts are moved in rather than lost.
export function keepTrayAcrossMorph (event) {
  if (!event.target.matches?.('[data-flash-tray]')) return

  event.preventDefault()
  event.target.append(...event.detail.newElement.children)
}

const topMostHost = () => {
  const dialogs = Array.from(document.querySelectorAll('#dialogs > dialog'))

  return dialogs.findLast((dialog) => dialog.open) || document.body
}

// The layouts render a tray (Ui::Flash::Component), so a plain page load has
// one; a dialog gets its own on demand and discards it on close.
const flashTrayIn = (host) => {
  const existing = host.querySelector(':scope > [data-flash-tray]')
  if (existing) return existing

  const tray = document.createElement('div')
  tray.className = 'flash'
  tray.dataset.flashTray = ''

  return host.appendChild(tray)
}
